const classNames = (...args)=>args.filter(Boolean).join(" ");

export { classNames };
//# sourceMappingURL=class-names.js.map
